export const PageDataState = {
    Searchs: {
        supply_hr_id: {
            type: 'text',
            id: 'supply_hr_id',
            label: '',
            value: '',
            placeholder: ''
        },
        skills_set_type_id: {
            type: 'select',
            id: 'skills_set_type_id',
            label: 'ประเภททักษะ',
            value: '',
            placeholder: 'ประเภททักษะ Skills Set'
        },
    },
    Inputs: {
        id: {
            type: 'text',
            id: 'id',
            label: 'รหัส',
            value: '',
            validator: {
                type: 'primaryKey',
                required: false
            },
            error: { status: null, msg: '' }
        },
        supply_hr_id: {
            type: 'select',
            id: 'supply_hr_id',
            label: 'สาขางาน',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },
        skills_set_type_id: {
            type: 'select',
            id: 'skills_set_type_id',
            label: 'ประเภททักษะ Skills Set',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        }, 
        skills_set_id: {
            type: 'select',
            id: 'skills_set_id',
            label: 'ทักษะ Skills Set',
            value: '',
            validator: {
                type: 'text',
                required: true
            },
            error: { status: null, msg: '' }
        },                                   
    },
    InputGroup: {}
}